module.exports = __webpack_public_path__ + "media/images/question-66ce3ebb6198af00840177e1f6910730.svg";